import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchFleetbackInterventions(params) {
  try {

    const response = yield call(() => Api.get(`/fleetback/${params.interventionId}`));

    yield put({type: 'FETCH.FLEETBACK_INTERVENTIONS.SUCCESS', response})
  } catch (error) {
    yield put({type: 'FETCH.FLEETBACK_INTERVENTIONS.FAILURE', error})
  }
}
function* saveSendFleetbackIntervention(params) {
  try {

    const response = yield call(() => Api.post(`/fleetback/send/${params.fleetbackId}`));

    yield put({type: 'SAVE.SEND_INTERVENTION.SUCCESS', response})
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
  } catch (error) {
    yield put({type: 'SAVE.SEND_INTERVENTION.FAILURE', error})
  }
}

export function* watchFetchFleetbackInterventions() {
  yield takeEvery('FETCH.FLEETBACK_INTERVENTIONS.REQUEST', fetchFleetbackInterventions);
  yield takeEvery('SAVE.SEND_INTERVENTION.REQUEST', saveSendFleetbackIntervention);
}



// WEBPACK FOOTER //
// ./src/sagas/fleetback.js